module.exports = __webpack_public_path__ + "static/img/9_fun.7da8a78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/9_fun.png
// module id = bzCa
// module chunks = 0